import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/marketing/admin/adminMarketingQueryKeys.ts
var t = e("admin-marketing", {
	list: (e) => e ? ["list", e] : ["list"],
	detail: (e) => ["detail", e],
	analytics: (e, t) => t ? [
		"analytics",
		e,
		t
	] : ["analytics", e]
});
//#endregion
export { t as adminMarketingQueryKeys };
